// Mobile product-card carousel: swipe through images + tap dots.
// Desktop keeps the existing hover-to-show-second-image behaviour because
// .product-card__image-hover is rendered the same way as before.

(function () {
  const SWIPE_THRESHOLD = 30; // px

  function setActive(card, idx) {
    const imgs = card.querySelectorAll('.product-card__image');
    const dots = card.querySelectorAll('[data-card-dot-index]');
    if (idx < 0) idx = imgs.length - 1;
    if (idx >= imgs.length) idx = 0;
    imgs.forEach((img, i) => img.classList.toggle('is-active', i === idx));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    card.dataset.activeIndex = String(idx);
  }

  function activeIndex(card) {
    return parseInt(card.dataset.activeIndex || '0', 10) || 0;
  }

  function wire(card) {
    if (card.dataset.carouselInit === '1') return;
    card.dataset.carouselInit = '1';
    card.dataset.activeIndex = '0';

    // Dot click - jump directly, stop the parent anchor's navigation.
    card.querySelectorAll('[data-card-dot-index]').forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const idx = parseInt(dot.dataset.cardDotIndex, 10);
        if (!isNaN(idx)) setActive(card, idx);
      }, { passive: false });
    });

    // Touch swipe
    let startX = 0;
    let startY = 0;
    let startTime = 0;
    let swiped = false;

    card.addEventListener('touchstart', (e) => {
      const t = e.changedTouches[0];
      startX = t.clientX;
      startY = t.clientY;
      startTime = Date.now();
      swiped = false;
    }, { passive: true });

    card.addEventListener('touchmove', (e) => {
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      // Mostly-horizontal gesture = treat as carousel swipe and prevent
      // the page's vertical scroll from stealing focus.
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        swiped = true;
      }
    }, { passive: true });

    card.addEventListener('touchend', (e) => {
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        // It's a swipe. Block the parent anchor click that follows touchend.
        e.preventDefault();
        e.stopPropagation();
        const idx = activeIndex(card);
        setActive(card, dx < 0 ? idx + 1 : idx - 1);
        // Swallow the synthesized click that would follow this touchend.
        const blockClick = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          card.removeEventListener('click', blockClick, true);
        };
        card.addEventListener('click', blockClick, true);
      }
    }, { passive: false });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-card-carousel]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Re-wire after async grid loads (e.g. infinite scroll, filter refresh)
  document.addEventListener('product-grid:updated', (e) => initAll(e.target));
})();
